import { User } from "./user";
import { Client } from "@/types/client";

export enum MeetingType {
  ONLINE = "ONLINE",
  INPERSON = "INPERSON",
  CALL = "CALL",
}

export interface MeetingInvitee {
  clientId: string;
  email: string;
  id: string;
  meetingId: string;
  name?: string;
  organizer: boolean;
  userId?: string;
}

export interface Participant {
  id: string;
  email?: string;
  name?: string;
  conversationId?: string;
  clientId?: string;
  userId?: string;
  speakerId?: string | null;
  client?: Client | null;
  user?: User | null;
}

export type MeetingConversation = {
  title?: string | null;
  id: string;
  hasSummary: boolean;
  createdAt: number;
};

export type Meeting = {
  id: string;
  userId: string;
  owner: User;
  recorded: boolean;
  startAt: number;
  endAt: number;
  botId?: string;
  botStatus?: string;
  botStatusReason?: string;
  calendarId?: string;
  title?: string;
  /**
   * @deprecated Legacy single-conversation link retained only for backend
   * rollout compatibility. Home-page behavior should use `conversations`.
   */
  conversationId?: string | null;
  conversations: MeetingConversation[];
  recurrenceId?: string | null;
  deduplicationKey: string;
  meetingType: MeetingType;
  deletedAt?: number | null;
  participants?: Participant[];
  meetingPrepId?: string;
  invitees?: MeetingInvitee[];
};
